var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"loading-spinner-img",attrs:{"alt":"spinner","src":require('@/assets/spinner-black.png')}})
}
var staticRenderFns = []

export { render, staticRenderFns }